import { Model } from 'dva'
import { AuditLogsReducerState, AuditRequestParams } from './types'

const initialState: AuditLogsReducerState = {
  filters: {},
}

const AuditLogs: Model = {
  namespace: 'auditLogs',
  state: initialState,
  effects: {},
  reducers: {
    setFilter: (state, action) => {
      const filters: { [T in keyof AuditRequestParams]: AuditRequestParams[T] } = action.payload

      if (!filters) {
        console.error('Received invalid filter object')
        return state
      }

      return {
        ...state,
        filters: {
          ...state.filters,
          ...filters,
        },
      }
    },
    resetAuditLogs(state, action) {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default AuditLogs
